import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    title: 'Identifica',
    desc: 'usa el Diario de Frecuencia y detecta tu patrón nocturno.'
  }, {
    title: 'Elimina',
    desc: 'aplica la cena sin irritantes (y usa el Bono #1 para no improvisar).'
  }, {
    title: 'Vacía',
    desc: 'ejecuta el vaciado completo y corta el residuo antes de dormir.'
  }, {
    title: 'Si te despiertas',
    desc: 'aplicas el Bono #2 "3AM" y vuelves a dormir sin perder la noche.'
  }];
  return <section className="bg-navy-900 py-14 md:py-20 relative text-cream-50" data-id="element-174">
      <div className="container mx-auto px-4" data-id="element-175">
        <div className="max-w-[720px] mx-auto" data-id="element-176">
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-177">
            <div className="w-12 h-px bg-gold-500/30" data-id="element-178" />
            <div className="w-1.5 h-1.5 rotate-45 bg-gold-500/50" data-id="element-179" />
            <div className="w-12 h-px bg-gold-500/30" data-id="element-180" />
          </div>
          <FadeIn data-id="element-181">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-center mb-16 text-white" data-id="element-182">
              Cómo Funciona
            </h2>
          </FadeIn>

          <div className="space-y-6" data-id="element-183">
            {steps.map((step, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-184">
                <div className="bg-navy-800 rounded-2xl p-6 md:p-8 border border-navy-700 flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-185">
                  <div className="w-14 h-14 shrink-0 bg-gold-500 rounded-full flex items-center justify-center text-navy-950 font-bold text-2xl shadow-lg" data-id="element-186">
                    {i + 1}
                  </div>
                  <div data-id="element-187">
                    <span className="text-xl font-heading font-bold text-gold-400 mr-2" data-id="element-188">
                      {step.title}:
                    </span>
                    <span className="text-lg text-cream-100/90" data-id="element-189">
                      {step.desc}
                    </span>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}